function renderWishlistCounter(swat) {
    var counter_elem = document.getElementById("wishlist-counter");

    if (counter_elem && swat && typeof swat.renderWishlistCount === 'function') {
        swat.renderWishlistCount(counter_elem);
        window.setTimeout(function() {
            var count = parseInt(counter_elem.textContent, 10) || 0;
            counter_elem.style.display = count > 0 ? "block" : "none";
        }, 0);
    }
}

// iOS WebKit does not repaint an element whose classes/content were mutated by JS
// while it sits inside a position:fixed ancestor (the mobile product buy bar). Swym
// adds its classes to the wishlist hearts after load, so on iPhone they stay blank
// (space reserved, nothing drawn) until a reflow. Toggling display forces that reflow.
function repaintProductWishlistButtons() {
    var btns = document.querySelectorAll('.product-form__wishlist .product-form__wishlist-button');
    for (var i = 0; i < btns.length; i++) {
        var el = btns[i];
        el.style.display = 'none';
        void el.offsetHeight; // force reflow
        el.style.display = ''; // revert to stylesheet value (flex / none)
    }
}

if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}
window.SwymCallbacks.push(renderWishlistCounter);
window.SwymCallbacks.push(repaintProductWishlistButtons);
window.addEventListener('load', function () {
    requestAnimationFrame(repaintProductWishlistButtons);
});
